import { Component, Inject } from '@angular/core';
import { DialogBelonging } from '@costlydeveloper/ngx-awesome-popup';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dialog-error-bonds',
  templateUrl: './dialog-error-bonds.component.html',
  styleUrls: ['./dialog-error-bonds.component.scss']
})
export class DialogErrorBondsComponent {

  public data;
  private subscriptions: Subscription = new Subscription();

  constructor(@Inject('dialogBelonging') public dialogBelonging: DialogBelonging) { }

  ngOnInit() {
    this.data = this.dialogBelonging.customData;

    this.subscriptions.add(
      this.dialogBelonging.eventsController.onButtonClick$.subscribe((_Button) => {
        if (_Button.ID === 'submit') {
          this.dialogBelonging.eventsController.close();
        }
      })
    );
  }

}
